import { StandardProps } from "@/components/componentMap";
import { useVariant } from "@/hooks/useVariant/useVariant";
import {
  ensureIsActive,
  ensureIsActiveVariant,
} from "@/utils/product/ensureIsActive";
import AvailableServices, {
  BasketMode,
} from "@/components/PostAddToBasketDrawer/components/AvailableServices.tsx";
import { getScheme } from "@/components/PostAddToBasketDrawer/scheme/schemeDecisioner.ts";
import { ProtectPlusComplianceDrawerUI } from "@/components/PostAddToBasketDrawer/ProtectPlusComplianceDrawerUI.tsx";

type Props = Partial<StandardProps> &
  Pick<StandardProps, "product" | "runtimeConfig">;

export function PostAddToBasketDrawer({
  configProps,
  product,
  runtimeConfig,
}: Props) {
  const { variant, isSelected } = useVariant(product);

  const { services = [] } = variant;
  const { brand } = product;

  const isShipFromStore = variant.availability?.shipFromStore === true;
  const expressCheckoutEnabled = configProps?.expressCheckoutEnabled === true;

  const appleProduct = brand?.name.toLowerCase() === "apple";

  const deliveryAndWarrantyServices = services.filter(({ __typename }) =>
    ["DeliveryService", "ExtendedWarranty"].includes(__typename),
  );

  const guarantees = services.filter(
    ({ __typename }) => __typename === "IncludedGuarantee",
  );

  const warrantyServices = services.filter(
    ({ __typename }) => __typename === "ExtendedWarranty",
  );

  const activeProduct = ensureIsActive(product);

  const activeVariant = ensureIsActiveVariant(variant);

  if (!activeProduct || !activeVariant) return null;

  const isOutOfStock = !variant.availability?.availableToOrder;

  const skuId = activeVariant.aliases.skuId;

  let mode: BasketMode = BasketMode.Post;

  if (isShipFromStore || expressCheckoutEnabled || appleProduct) {
    mode = BasketMode.Pre;
  }

  const protectPlusScheme = getScheme(product);

  return (
    <>
      <AvailableServices
        variantServices={warrantyServices}
        protectPlusScheme={protectPlusScheme}
        mode={mode}
      />
      <ProtectPlusComplianceDrawerUI
        basketMode={mode}
        title={variant.title}
        variantServices={deliveryAndWarrantyServices}
        basketBaseUrl={runtimeConfig.basketApiBaseUrl}
        productId={activeProduct?.aliases.pimProductId}
        skuId={skuId}
        guarantees={guarantees}
        protectPlusScheme={protectPlusScheme}
        hideFooter={isOutOfStock || !isSelected}
      />
    </>
  );
}
